// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"476":"4abd4a190177f37d82de","972":"dcfb1c16134ba3fd90ad"}[chunkId] + ".chunk.js";
};